module.exports = __webpack_public_path__ + "static/rainbowspot1-82feaf0431f368e892c94a31d0d9c5a6.png";